import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import './Manage_User.css';
import Header from './Header.js';
import Sidebar from './Sidebar.js';
import Footer from './Footer.js';
import Pagination from './Pagination.js';
import * as XLSX from 'xlsx';

import { saveAs } from 'file-saver';
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
function Vehicle_Tracking() {
    const token = localStorage.getItem("authToken") || null;
    const navigate = useNavigate();

    const [vehicleList, setVehicleList] = useState([]);
    const [items, setItems] = useState([]);
    const [filteredItems, setFilteredItems] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [sortColumn, setSortColumn] = useState("id");
    const [sortOrder, setSortOrder] = useState("desc");
    const [isLoading, setIsLoading] = useState(true);
    const Loader = () => (
        <div style={{ textAlign: 'center', marginTop: '20px' }}>
            <div className="spinner-border" role="status">
                <span className="sr-only">Loading...</span>
            </div>
            <p>Loading...</p>
        </div>
    );

    //********* */
    const [is_travel_store, setis_travel_store] = useState(false);
    const userProfile = localStorage.getItem('userProfile');
    const userProfileData = JSON.parse(userProfile);
    useEffect(() => {
        if (userProfileData) {
            setis_travel_store(userProfileData.is_travel_store === 'Y' || userProfileData.is_it_admin === 'Y');
        }
    }, [userProfileData]);
    //********* */

    const fetchVehicleList = async () => {
        try {
            const response = await fetch(`${API_BASE_URL}vehicle_tracking`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const data = await response.json();
            console.log('Vehicle Tracking API Response:', data);

            if (data.status && Array.isArray(data.data)) {
                setVehicleList(data.data);
                setItems(data.data);
            } else {
                setVehicleList([]);
            }

            setIsLoading(false);
        } catch (error) {
            console.error('Error fetching vehicle tracking data:', error);
            setVehicleList([]);
            setIsLoading(false);
        }
    };

    useEffect(() => {
        if (token) {
            fetchVehicleList();
        }
    }, [token]);

    useEffect(() => {
        if (!Array.isArray(items)) {
            setFilteredItems([]);
            return;
        }

        const filtered = items.filter(item => {
            const empCode = item.emp_code?.toLowerCase() || "";
            const driverName = item.driver_name?.toLowerCase() || "";
            const vehicleNum = item.vehicle_number?.toLowerCase() || "";
            const searchQueryLower = searchQuery.toLowerCase();

            return (
                empCode.includes(searchQuery.toLowerCase()) ||
                driverName.includes(searchQuery.toLowerCase()) ||
                vehicleNum.includes(searchQuery.toLowerCase()) ||
                item.driver_mobile?.toLowerCase().includes(searchQueryLower) || 
                item.vehicle_type?.toLowerCase().includes(searchQueryLower) ||
                item.route?.toLowerCase().includes(searchQueryLower) ||
                item.rpt_mgr?.toLowerCase().includes(searchQueryLower) ||
                item.branch_manager_approval?.toLowerCase().includes(searchQueryLower) ||
                item.OTPverified_on?.toLowerCase().includes(searchQueryLower) ||
                item.isOTPverified?.toLowerCase().includes(searchQueryLower) ||
                item.emp_code.toLowerCase().includes(searchQueryLower)  
            );
        });

        const sorted = filtered.sort((a, b) => {
            if (a[sortColumn] < b[sortColumn]) return sortOrder === "asc" ? -1 : 1;
            if (a[sortColumn] > b[sortColumn]) return sortOrder === "asc" ? 1 : -1;
            return 0;
        });

        setFilteredItems(sorted);
        setCurrentPage(1);
    }, [searchQuery, items, sortColumn, sortOrder]);

    const totalPages = Math.ceil(filteredItems.length / itemsPerPage);
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = filteredItems.slice(indexOfFirstItem, indexOfLastItem);

    const startItem = indexOfFirstItem + 1;
    const endItem = Math.min(indexOfLastItem, filteredItems.length);

    const handleSearchChange = e => {
        setSearchQuery(e.target.value);
    };

    const handlePageChange = pageNumber => {
        setCurrentPage(pageNumber);
    };

    const handleItemsPerPageChange = e => {
        setItemsPerPage(Number(e.target.value));
        setCurrentPage(1);
    };

    const handleSort = column => {
        if (sortColumn === column) {
            setSortOrder(sortOrder === "asc" ? "desc" : "asc");
        } else {
            setSortColumn(column);
            setSortOrder("asc");
        }
    };

    const formatDate = (dateStr) => {
        const date = new Date(dateStr);
        if (isNaN(date)) return "Invalid Date";

        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
        const year = date.getFullYear();

        return `${day}-${month}-${year}`;
    };

    const exportToExcel = () => {
        // Define custom column headers and their corresponding field names
        const columns = [
            { header: 'Employee Code', field: 'emp_code' },
            { header: 'Driver Name', field: 'driver_name' },
            { header: 'Mobile Number', field: 'driver_mobile' },
            { header: 'Vehicle Number', field: 'vehicle_number' },
            { header: 'Vehicle Type', field: 'vehicle_type' },
            { header: 'Route', field: 'route' },
            { header: 'Created Date', field: 'created_at' }
        ];

        // Create formatted data with selected columns in specified order
        const formattedData = vehicleList.map(item => {
            const row = {};
            columns.forEach(col => {
                row[col.header] = item[col.field];
            });
            return row;
        });

        const worksheet = XLSX.utils.json_to_sheet(formattedData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "VehicleTracking");

        const excelBuffer = XLSX.write(workbook, {
            bookType: "xlsx",
            type: "array"
        });

        const data = new Blob([excelBuffer], { type: "application/octet-stream" });
        saveAs(data, "vehicle_tracking.xlsx");
    };

    return (
        <div className="hold-transition sidebar-mini layout-fixed" style={{ fontSize: '12px' }}>
            <div className="wrapper">
                <Header />
                <Sidebar />
                <div className="content-wrapper">
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-6">
                                    <h4 className="m-0" style={{ fontSize: '20px' }}>Vehicle Tracking List</h4>
                                </div>
                                <div className="col-sm-6">
                                    <ol className="breadcrumb float-sm-right">
                                        <li className="breadcrumb-item" style={{ fontSize: '12px' }}><Link to="/dashboard">Home</Link></li>
                                        <li className="breadcrumb-item active" style={{ fontSize: '12px' }}>Vehicle Tracking</li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>

                    <section className="content">
                        <div className="container-fluid">
                            <div className="row">
                                <section className="col-lg-12 connectedSortable">
                                    <div className="card">
                                        <div className="card-header">
                                            <div className="d-flex justify-content-end">
                                                {is_travel_store && (
                                                    <Link to="/add_vehicle_tracking">
                                                        <button type="button" className="btn btn-sm btn-success mr-2">Add New</button>
                                                    </Link>
                                                )}
                                                <button onClick={exportToExcel} className="btn btn-sm btn-secondary">Export to Excel</button>

                                            </div>
                                        </div>
                                        <div className="card-body">
                                            {isLoading ? (
                                                <Loader />
                                            ) : vehicleList.length === 0 ? (
                                                <p>No vehicle tracking records found.</p>
                                            ) : (
                                                <>
                                                    <div id="example1_filter" style={{ float: 'right' }} className="dataTables_filter">
                                                        <label>
                                                            <input
                                                                type="search"
                                                                value={searchQuery}
                                                                onChange={handleSearchChange}
                                                                className="form-control form-control-sm"
                                                                placeholder="Search by Emp Code, Driver or Vehicle"
                                                                aria-controls="example1"
                                                            />
                                                        </label>
                                                    </div>

                                                    <div className="form-group">
                                                        <select
                                                            className="form-control custom-select-sm"
                                                            value={itemsPerPage}
                                                            onChange={handleItemsPerPageChange}
                                                        >
                                                            <option value={10}>10</option>
                                                            <option value={50}>50</option>
                                                            <option value={100}>100</option>
                                                        </select>
                                                    </div>

                                                    <div className="table-responsive">
                                                        <table className="table table-hover text-nowrap">
                                                            <thead>
                                                                <tr>
                                                                    <th>#</th>
                                                                    <th>Driver</th>
                                                                    <th>Driver Mobile</th>
                                                                    <th>Vehicle No.</th>
                                                                    <th>Vehicle Type</th>
                                                                    <th>Route</th>
                                                                    <th>OTP Verified</th>
                                                                    <th>Verified At</th>
                                                                    <th>Created By</th>
                                                                    <th>Action</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {currentItems.length > 0 ? (
                                                                    currentItems.map((item, index) => (
                                                                        <tr key={index}>
                                                                            <td>{index + 1 + (currentPage - 1) * itemsPerPage}</td>

                                                                            <td>{item.driver_name}</td>
                                                                            <td>{item.driver_mobile}</td>
                                                                            <td>{item.vehicle_number}</td>
                                                                            <td>{item.vehicle_type}</td>
                                                                            <td>{item.route}</td>
                                                                            <td>
                                                                                <span style={{
                                                                                    color: item.isOTPverified === 'Yes' ? "green" :
                                                                                        item.isOTPverified === 'No' ? "red" : "black"
                                                                                }}>
                                                                                    {item.isOTPverified === 'Yes' ? "Yes" : "Pending"}
                                                                                </span>
                                                                            </td>
                                                                            <td>
                                                                                {item.OTPverified_on && item.OTPverified_on !== "0000-00-00 00:00:00"
                                                                                    ? formatDate(item.OTPverified_on)
                                                                                    : "N/A"}
                                                                            </td>
                                                                            <td>{item.emp_code}</td>
                                                                            <td>
                                                                                <Link to={`/edit_vehicle_tracking/${item.id}`}>
                                                                                    <i className="fa fa-edit" style={{ fontSize: '14px', color: 'green', cursor: 'pointer' }}></i>
                                                                                </Link>
                                                                            </td>
                                                                        </tr>
                                                                    ))
                                                                ) : (
                                                                    <tr>
                                                                        <td colSpan='10'>No data available</td>
                                                                    </tr>
                                                                )}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </>
                                            )}
                                        </div>
                                    </div>
                                    <Pagination
                                        currentPage={currentPage}
                                        totalPages={totalPages}
                                        handlePageChange={handlePageChange}
                                    />
                                    <div className="mb-3">
                                        Showing {startItem} to {endItem} of {filteredItems.length} entries
                                    </div>
                                </section>
                            </div>
                        </div>
                    </section>
                </div>
                <Footer />
            </div>
        </div>
    );
}

export default Vehicle_Tracking;
